import { render, staticRenderFns } from "./notOpen.vue?vue&type=template&id=372a36ce"
import script from "./notOpen.vue?vue&type=script&lang=js"
export * from "./notOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports